"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoderBase = void 0;
var DecoderBase = (function () {
    function DecoderBase() {
    }
    DecoderBase.decode = function (str, specifiedSymbols) {
        if (str == null) {
            return null;
        }
        var result = "";
        for (var i = 0; i < str.length; i++) {
            var sourceCharCode = str.charCodeAt(i);
            var target = specifiedSymbols[sourceCharCode];
            var targetCharCode = target !== undefined ? target : sourceCharCode;
            result = result + String.fromCharCode(targetCharCode);
        }
        return result;
    };
    return DecoderBase;
}());
exports.DecoderBase = DecoderBase;
